export const LogoMark = ({ className = 'h-9 w-9' }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="2" y="2" width="60" height="60" rx="20" fill="#FFD400" />
    <text x="33" y="48" textAnchor="middle" fontFamily="Nunito, 'Arial Rounded MT Bold', Arial, sans-serif" fontWeight="900" fontSize="46" fill="#000000">J</text>
  </svg>
);

export const Logo = ({ size = 'md' }) => (
  <span className="flex items-center gap-2 group">
    <LogoMark className={size === 'lg' ? 'h-12 w-12' : 'h-9 w-9'} />
    <span className={`brand-word font-extrabold tracking-widest leading-none text-black ${size === 'lg' ? 'text-2xl' : 'text-lg sm:text-xl'}`}>
      JOTALY
    </span>
  </span>
);
